module.exports = "<div class=\"form-group\">\n    <label class=\"itpx-label\">\n        <ng-content select=[input-label]></ng-content>\n        <ng-template [ngIf]=\"!required\">\n            <span class=\"label-separator\">-</span>\n            <span class=\"optional-mark\">Optional</span>\n        </ng-template>\n    </label>\n    <p class=\"itpx-under-label\">\n        <ng-content select=[input-guidance]></ng-content>\n    </p>\n    <ng-content select=[input-group]></ng-content>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/happy/happy-control-group/happy-control-group-input.component.html
// module id = 957
// module chunks = 0